import React from 'react';

export const EmptyState = ({ message }) => (
  <div className="text-center py-5">
    <p className="text-muted">{message || 'No data available'}</p>
  </div>
);
